import React, { useState, useEffect } from "react";
import { HeaderComponent, TableComponent, BodyComponent, ActionComponent, trans, Switch } from '@comps/components';
import { makeRequest } from '@utils/helpers';
import { getRolesReq, changeStatusReq, deleteRoleReq } from './requests';
import { updateById, deleteById } from '@comps/commonFunctions';
import { Icon } from "@iconify/react";
import { Tooltip } from "antd";
import CreateRole from "./components/CreateRole";
import UpdateRole from "./components/UpdateRole";
import UpdatePermissions from "./components/UpdatePermissions";

const langKey = 'UserManagement.roles';

const pageConfig = {
  headers: {
    title: trans(`${langKey}.moduleName`),
    breadcrumb: [
      {
        name: trans(`${langKey}.moduleName`),
        path: "/user-management/roles"
      }
    ]
  }
}

const module = 'roles';

const IndexRoles = () => {
  const [dataSource, setDataSource] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loader, setLoader] = useState(false);
  const [childComponent, setChildComponent] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    showSizeChanger: true,
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
  });

  useEffect(() => {
    getRolesData();
  }, [pagination]); // eslint-disable-line react-hooks/exhaustive-deps

  const getRolesData = () => {
    makeRequest(setLoader, getRolesReq, null, onSuccess, onError);
  }

  const onError = (error) => {
    console.log(error);
  }

  const onSuccess = (data) => {
    setDataSource(data.data);
    setTotalRecords(data.totalRecords);
  }

  const handleTableChange = (page, fil, sorter) => {
    let payload = {
      ...pagination,
      current: page.current,
      pageSize: page.pageSize,
      sortName: sorter.field || 'id',
      sortType: sorter.order === 'ascend' ? 'asc' : 'desc',
    };
    setPagination(payload);
  }


  const columns = [
    {
      title: trans(`common.name`),
      dataIndex: "name",
      key: "name",
      sorter: true,
    },
    {
      title: trans(`common.active`),
      render: (data) => {
        return (
          <Switch onChange={ (action) => onChangeStatus(data, action) } checked={ data.is_active } />
        )
      }
    },
    {
      title: trans(`common.actions`),
      render: (record) => record.id !== 2 && <ActionComponent module={ module } each={ record } onEdit={ onEdit } onDelete={ onDelete } >
        <Tooltip title="Update permissions">
          <button type="button" className="row-action" onClick={ () => onPermissionChange(record.id) } aria-label="Update permissions">
            <Icon icon="tabler:key" width={ 18 } />
          </button>
        </Tooltip>
      </ActionComponent>
    },
  ];

  const onPermissionChange = (roleId) => {
    setChildComponent(<UpdatePermissions roleId={ roleId } onUpdated={ onUpdated } onClosed={ onClosed } />);
  }

  const onChangeStatus = (data, action) => {
    let payload = {
      id: data.id,
      status: action
    };
    makeRequest(setLoader, changeStatusReq, payload, onChangeStatusSuccess, onChangeStatusError);
  }

  const onChangeStatusSuccess = (data) => {
    let index = dataSource.findIndex(each => each.id === data.id);
    dataSource[index].is_active = data.is_active;
    setDataSource([...dataSource]);
  }

  const onChangeStatusError = (error) => {
    console.log(error);
  }

  const onCreate = () => {
    setChildComponent(<CreateRole onCreated={ onCreated } onClosed={ onClosed } />);
  }

  const onCreated = (data) => {
    setDataSource([data, ...dataSource]);
    setChildComponent(null);
  }


  const onEdit = (record) => {
    setChildComponent(<UpdateRole data={ record } onUpdated={ onUpdated } onClosed={ onClosed } />);
  }

  const onUpdated = (data) => {
    setDataSource([...updateById(dataSource, data)]);
    setChildComponent(null);
  }

  const onDelete = (record) => {
    makeRequest(setLoader, deleteRoleReq, record.id, onDeleteSuccess, Function);
  }

  const onDeleteSuccess = (data) => {
    setDataSource([...deleteById(dataSource, data)]);
  }

  const onClosed = () => {
    setChildComponent(null);
  }

  return (
    <>
      { childComponent }
      <HeaderComponent headers={ pageConfig.headers } description="Roles group permissions, and every user is given one." />
      <BodyComponent flush module={ module } onCreate={ onCreate }>
        <TableComponent loader={ loader } columns={ columns } dataSource={ dataSource } emptyState={ { icon: "tabler:shield-lock", title: "No roles yet", description: "Create a role to control what a group of users can do." } } pagination={ { ...pagination, total: totalRecords } } onChange={ handleTableChange } />
      </BodyComponent>
    </>
  )

}

export default IndexRoles